import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';

import Container from './Container';
import CloudinaryImage from './CloudinaryImage';

import './vlinkservicegrid.css';

export default function VlinkServicesGrid({ whyvlink, blackBg }) {
  return (
    <Container>
      <div
        className={`${whyvlink?.title && 'xl:mb-[34px] mb-[30px] max-w-[1100px]'}`}
      >
        {whyvlink?.bg_title && (
          <h2
            className={`${blackBg ? 'text-[#ffffff]' : 'text-[#000B1C]'} lg:text-[24px] md:text-[20px] text-[16px] font-[500] mb-3`}
          >
            {whyvlink?.bg_title}
          </h2>
        )}
        {whyvlink?.title && (
          <h2
            className={`${blackBg ? 'text-[#ffffff]' : 'text-[#000B1C]'} font-[800] xl:text-[55px] md:text-[32px] text-[25px] leading-tight`}
          >
            {whyvlink?.title}
          </h2>
        )}
        {whyvlink?.description && (
          <p
            className={`${blackBg ? 'text-[#ffffff]' : 'text-[#000B1C]'} text-[#00102B] lg:text-[24px] md:text-[20px] text-[14px] font-[400]`}
          >
            {whyvlink?.description}
          </p>
        )}
      </div>
      <div className="grid xl:grid-cols-4 md:grid-cols-2 grid-cols-1 gap-6 transation-custom">
        {whyvlink?.reasonList?.map(data => (
          <div
            key={data?.id}
            className={`transation-custom ${blackBg ? 'bg-[#131A26] hoverstyle' : 'bg-[#E8F1FF] hover:bg-[linear-gradient(180deg,_#0050D5_0%,_#020150_100%)]'} py-7 px-5 rounded-[20px] group`}
          >
            {data?.image?.data?.map(
              img =>
                img?.attributes?.url && (
                  <div
                    className={`mb-3 ${
                      blackBg
                        ? 'w-[60px] h-[60px] rounded-[4px] flex items-center justify-center group-hover:bg-[#0050D5] bg-[#272F3B]'
                        : 'flex items-center justify-center w-[60px] h-[60px] rounded-[4px]'
                    }`}
                    key={img?.id}
                  >
                    <CloudinaryImage
                      backendImgUrl={img?.attributes?.url}
                      className={`${blackBg ? 'w-[40px] h-[40px]' : 'w-[60px] h-[60px]'}`}
                      alt={img?.attributes?.alternativeText}
                      type="icon"
                    />
                  </div>
                )
            )}
            {data?.title && (
              <h4
                // href={`${data?.headingLink}`}
                className={`${blackBg ? 'text-[#ffffff]' : 'text-[#000A1B] group-hover:text-[#ffffff]'} block text-[24px] font-[700] mb-1`}
              >
                {data?.title}
              </h4>
            )}
            {data?.editor && (
              <ReactMarkdown
                rehypePlugins={[rehypeRaw]}
                className={`${blackBg ? 'text-[#ffffff]' : 'text-[#272727] group-hover:text-[#ffffff]'} text-[16px] font-[400]`}
                source={data?.editor}
              >
                {data?.editor}
              </ReactMarkdown>
            )}
          </div>
        ))}
      </div>
    </Container>
  );
}
